export default __webpack_public_path__ + "static/media/cpv_73_research-development.cad6fa02.svg";